const mainImprint = `
<h3>Angaben gemäß § 5 TMG:</h3>
<p>
  Tür an Tür – Digital Factory gGmbH<br />
  Wertachstr. 29<br />
  86153 Augsburg
</p>
<p>vertreten durch Antonia Hauf, Daniel Kehne</p>
<p>
  Aufsichtsbehörde: Finanzamt Augsburg-Stadt<br />
  Sitz der Gesellschaft: Augsburg<br />
  Handelsregister und Registernummer: HRB30759<br />
  Umsatzsteuer-Identifikationsnummer: DE307491397
</p>
<h3>Kontakt:</h3>
<table>
  <tbody>
  <tr>
    <td>Telefon:</td>
    <td>0821 20991254</td>
  </tr>
  <tr>
    <td>E-Mail:</td>
    <td>info@integreat-app.de</td>
  </tr>
  </tbody>
</table>
<h3>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</h3>
<p>Tür an Tür – Digital Factory gGmbH<br />
  Wertachstr.
  29<br /> 86153 Augsburg
</p>
<h3>Haftungsausschluss (Disclaimer)</h3>
<p><strong>Haftung für Inhalte</strong></p>
<p>
  Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen
  Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet,
  übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf
  eine
  rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
  Informationen
  nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem
  Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden
  Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
</p>
<p><strong>Haftung für Links</strong></p>
<p>
  Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben.
  Deshalb
  können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist
  stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum
  Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt
  der
  Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne
  konkrete
  Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir
  derartige Links umgehend entfernen.
</p>
<p><strong>Urheberrecht</strong></p>
<p>Die durch die Seitenbetreiber
  erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
  Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
  schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für
  den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber
  erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche
  gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
  entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend
  entfernen.
</p>
<p><strong>Urheber- und Nutzungsrecht</strong></p>
<p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. 
Alle auf www.netzwerkobdachwohnen.de befindlichen Inhalte sind unter der Creative Commons-Lizenz <a href="https://creativecommons.org/licenses/by/4.0/">CC BY-NC 4.0</a> lizenziert.
</p>
`
export default mainImprint
